import { connect } from 'react-redux';
import {
  getIsHotelOnly,
  getIsMobile,
  getIsWhitelabel,
} from 'src/store/view/selectors';
import { cheapestFlightTourIdSelector } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/selectors';
import { selectNewPrice } from 'src/routes/Checkout/store/selectors/price';
import {
  getHotelTitle,
  getHotelStars,
  getHotelLocation,
  getHotelImagesGallery,
  getHotelRating,
  getHotelCoordinates,
  getHotelRoulette,
  getHotelMetapolicies,
} from '../../../../store/selectors/hotel';
import { hotelLabelsSelector } from '../../../../store/selectors/tour';
import { getSimilarPackagesHasAdjustParams } from '../../../../store/selectors/similar-packages';
import Hotel from './components/Hotel';
import {
  getIsExpanded,
  getIsWebGlSupported,
} from '../../../../store/selectors/view';
import {
  getArchivedAt,
  getCancellationPolicy,
  getHotelAvailability,
  getIsManualPackage,
  getNotices,
  getPackageId,
} from '../../../../store/selectors/package';
import { toggleMapAction } from '../../../../store/actions/view';

const mapStateToProps = (state) => {
  const tour_id = cheapestFlightTourIdSelector(state);
  return {
    name: getHotelTitle(state),
    price: selectNewPrice(state),
    stars: getHotelStars(state),
    location: getHotelLocation(state),
    images: getHotelImagesGallery(state),
    rating: getHotelRating(state),
    coordinates: getHotelCoordinates(state),
    isMapExpanded: getIsExpanded(state),
    notices: getNotices(state),
    isWebGlSupported: getIsWebGlSupported(state),
    availability: getHotelAvailability(state),
    labels: hotelLabelsSelector(state, tour_id),
    isManualPackage: getIsManualPackage(state),
    hasAdjustParams: getSimilarPackagesHasAdjustParams(state),
    isRoulette: getHotelRoulette(state),
    hotelMetapolicies: getHotelMetapolicies(state),
    cancellationPolicy: getCancellationPolicy(state),
    isHotelOnly: getIsHotelOnly(state),
    isMobile: getIsMobile(state),
    archivedAt: getArchivedAt(state),
    packageId: getPackageId(state),
    isWhiteLabel: getIsWhitelabel(state),
  };
};

const mapDispatchToProps = {
  toggleMap: toggleMapAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Hotel);
